module.exports = __webpack_public_path__ + "static/media/1.1 Barbara Vorzustand.46f87379.jpg";